import React, {
  memo, useCallback, useRef, useState,
} from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import usePageProps from 'hooks/usePageProps'

import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'

import Draggable from 'components/Draggable'
import { toggleValueFromString } from 'utils/universal'
import { setFilters } from 'redux/modules/map'
import { useDispatch } from 'react-redux'
import sx from './styles'
import CategoryFilterCard from './CategoryFilterCard'

const CategoriesRow = ({ categoryFilters, onChange }) => {
  const dispatch = useDispatch()
  const { categories } = usePageProps()
  const [open, setOpen] = useState(false)
  const dragRef = useRef(null)

  const toggleOpen = () => {
    setOpen((prev) => !prev)
  }

  const handleChange = useCallback((category) => {
    const newCategoryValue = toggleValueFromString(categoryFilters, category)
    dispatch(setFilters({ category: newCategoryValue }))
    onChange({ category: newCategoryValue })
  }, [categoryFilters])

  const button = (
    <Button
      sx={sx.button}
      className="slim"
      startIcon={open ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
      onClick={toggleOpen}
    >
      <FormattedMessage id="ACTIVITIES" />
    </Button>
  )

  const categoriesList = (
    <Draggable innerRef={dragRef}>
      <Grid
        item
        xs={12}
        marginTop={1}
        sx={sx.filtercontainer}
      >
        {categories?.map((category) => (
          <CategoryFilterCard
            key={`category-${category?.id}`}
            item={category}
            onChange={handleChange}
            selected={categoryFilters?.includes(category?.slug)}
          />
        ))}
      </Grid>
    </Draggable>
  )

  return (
    <>
      <Box
        sx={sx.root}
        className={clsx({
          open,
        })}
      >
        <Box sx={{ margin: '0 auto' }}>
          {button}
        </Box>
        <Box
          sx={sx.categoriesContainer}
          className="Categories-root"
        >
          {categoriesList}
        </Box>

      </Box>

    </>
  )
}

export default memo(CategoriesRow)
